import { TFunction } from '@getpopsure/i18n-react';
import { AxiosError } from 'axios';

export const getErrorMessageTranslation = (
  t: TFunction,
  error: unknown | null
) => {
  const userFriendlyErrorMessages: Record<string, string> = {
    SOMETHING_WENT_WRONG: t(
      'updateEmail.codeConfirmation.sendVerificationCode.error',
      'Something went wrong. Please try again.'
    ),
    REQUEST_NOT_FOUND: t(
      'updateEmail.requestNotFound',
      "We couldn't find your request. Please try again."
    ),
    INVALID_CODE: t(
      'updateEmail.codeConfirmation.verifyCurrentEmail.invalidCode',
      'The code you entered is incorrect. Please try again.'
    ),
    REQUEST_CODE_EXPIRED: t(
      'updateEmail.codeConfirmation.verifyCurrentEmail.requestExpired',
      'The code you entered is expired. Please start over.'
    ),
    REQUEST_EXPIRED: t(
      'updateEmail.enterEmail.requestExpired',
      'The email update request is expired. Please start over.'
    ),
    FORBIDDEN: t(
      'updateEmail.forbidden',
      'You are not authorized to perform this action.'
    ),
    NEW_EMAIL_WAS_NOT_PROVIDED: t(
      'updateEmail.newEmailWasNotProvided',
      'Insufficient information. New email was not provided.'
    ),
  };

  if (
    error instanceof AxiosError &&
    error.response?.data &&
    typeof error.response.data === 'object' &&
    'errorType' in error.response.data
  ) {
    const errorMessage = error.response.data.errorType;

    return (
      userFriendlyErrorMessages[errorMessage] ||
      userFriendlyErrorMessages.SOMETHING_WENT_WRONG
    );
  }

  return userFriendlyErrorMessages.SOMETHING_WENT_WRONG;
};

export const getErrorMessage = (error: unknown | null): string | undefined => {
  if (
    error instanceof AxiosError &&
    error.response?.data &&
    typeof error.response.data === 'object' &&
    'errorType' in error.response.data
  ) {
    return error.response.data.errorType;
  }
};
